import { checkIsNestedKey } from 'components/shared/ExpandableToolbar/lib/helpers';

export const getNestedKeys = (obj = {}) => {
  const keys = [
    ...new Set(
      Object.keys(obj).map((key) => {
        const parts = key.split('.');
        const result = [];

        for (let i = 0; i < parts.length; i++) {
          result.push(parts[i]);
          // If the next part is a number, include it and stop
          if (i + 1 < parts.length && !isNaN(parts[i + 1]) && parts[i + 1] !== '') {
            result.push(parts[i + 1]);
            break;
          }
        }

        return result.join('.');
      })
    )
  ];
  // Separate keys with "." (nested) and without "." (non-nested)
  const nonNestedKeys = keys.filter((key) => !key.includes('.'));
  const nestedKeys = keys.filter((key) => key.includes('.'));

  // Return non-nested keys first, then nested keys
  return [...nonNestedKeys, ...nestedKeys.sort((a, b) => a.localeCompare(b))];
};

export const getNewNestedValue = (key, obj) => {
  const isNestedKey = checkIsNestedKey(key, obj);

  const objKeys = Object.keys(obj || {});

  if (objKeys.includes(key) || !isNestedKey) {
    return obj[key];
  }

  const newNestedValue = objKeys.reduce((acc, field) => {
    const restField = field.replace(`${key}.`, '');

    if (field.startsWith(`${key}.`)) {
      acc[restField] = obj[field];
    }

    return acc;
  }, {});

  return newNestedValue;
};
